import React from 'react';
import './StatChip.css';

export interface StatChipData {
    icon: string;
    value: string | number;
    label: string | string[];
    mutedText?: React.ReactNode;
}

const StatChip = ({ icon, value, label, mutedText }: StatChipData) => (
    <div className="stat-chip">
        <span className="material-symbols-rounded">{icon}</span>
        <div className="stat-chip-text">
            <b>{value}</b>
            {Array.isArray(label) ? (
                <div className="stat-chip-lines">
                    {label.map((line, i) => (
                        <span key={i} className="stat-chip-label">{line}</span>
                    ))}
                </div>
            ) : (
                <span className="stat-chip-label">{label}</span>
            )}
            {mutedText && <span className="stat-chip-muted">{mutedText}</span>}
        </div>
    </div>
);

export default StatChip;
